(function() {
  'use strict';

  function initShopTheLook(section) {
    if (!section || section.dataset.stlInitialized === 'true') {
      return;
    }

    section.dataset.stlInitialized = 'true';

    const redirectToCart = section.dataset.redirectToCart === 'true';

    function getRoot() {
      return window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root
        : '/';
    }

    function formatMoney(cents) {
      cents = Number(cents || 0);

      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }

      return (cents / 100).toFixed(2);
    }

    const tabs = section.querySelectorAll('[data-stl-tab]');
    const panels = section.querySelectorAll('[data-stl-panel]');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        const target = tab.dataset.stlTab;

        tabs.forEach(function(item) {
          const active = item === tab;

          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function(panel) {
          panel.classList.toggle(
            'is-active',
            panel.dataset.stlPanel === target
          );
        });
      });
    });

    panels.forEach(function(panel) {

      const products = Array.from(
        panel.querySelectorAll('.stl-product[data-variant-id]')
      );

      const hotspots = Array.from(
        panel.querySelectorAll('.stl-hotspot')
      );

      const button = panel.querySelector('[data-add-bundle]');
      const totalPrice = panel.querySelector('[data-total-price]');
      const errorBox = panel.querySelector('[data-bundle-error]');

      if (!button) {
        return;
      }

      function updateTotal() {

        let total = 0;
        let count = 0;

        products.forEach(function(product) {

          if (
            product.classList.contains('is-selected') &&
            product.dataset.available !== 'false'
          ) {

            total += Number(
              product.dataset.price || 0
            );

            count++;

          }

        });

        if (totalPrice) {
          totalPrice.textContent =
            formatMoney(total);
        }

        button.disabled = count === 0;
      }


      function toggleProduct(product) {

        if (!product) {
          return;
        }

        if (product.dataset.available === 'false') {
          return;
        }

        const selected = product.classList.contains('is-selected');

        if (selected) {
          removeProduct(product);
          return;
        }

        selectProduct(product);

      }

      function selectProduct(product) {

        if (!product) return;

        if (product.dataset.available === 'false') {
          return;
        }

        if (product.classList.contains('is-selected')) {
          return;
        }

        const index = product.dataset.productIndex;

        const slot = panel.querySelector(
          '.stl-product-slot[data-slot-index="' + index + '"]'
        );

        if (!slot) {
          return;
        }

        product.classList.add('is-selected');

        requestAnimationFrame(function () {
          product.animate(
            [
              { opacity: 0 },
              { opacity: 0.15, offset: 0.2 },
              { opacity: 0.5, offset: 0.55 },
              { opacity: 1, offset: 1 }
            ],
            {
              duration: 700,
              easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
              fill: 'both'
            }
          );
        });

        product.dataset.selected = 'true';

        product.setAttribute(
          'aria-pressed',
          'true'
        );

        slot.classList.add('has-product');

        slot.dataset.slotProduct = index;

        hotspots.forEach(function(hotspot) {

          if (
            hotspot.dataset.productIndex === index
          ) {
            hotspot.classList.add('is-active');
            hotspot.setAttribute(
              'aria-selected',
              'true'
            );
          }

        });

        updateTotal();

      }

      function removeProduct(product) {

        if (!product) return;

        const index = product.dataset.productIndex;

        product.classList.remove('is-selected');

        product.dataset.selected = 'false';

        product.setAttribute(
          'aria-pressed',
          'false'
        );

        const slot = panel.querySelector(
          '.stl-product-slot[data-slot-index="' + index + '"]'
        );

        if (slot) {

          slot.classList.remove(
            'has-product'
          );

          slot.dataset.slotProduct = '';

        }

        hotspots.forEach(function(hotspot) {

          if (
            hotspot.dataset.productIndex === index
          ) {

            hotspot.classList.remove(
              'is-active'
            );

            hotspot.setAttribute(
              'aria-selected',
              'false'
            );

          }

        });

        updateTotal();

      }


      products.forEach(function(product) {

        product.addEventListener('click', function(event) {

          if (
            event.target.closest('a') ||
            event.target.closest('button')
          ) {
            return;
          }

          toggleProduct(product);
        });

        product.addEventListener('keydown', function(event) {

          if (
            event.key === 'Enter' ||
            event.key === ' ' ||
            event.key === 'Spacebar'
          ) {

            event.preventDefault();

            toggleProduct(product);
          }

        });

      });

      products.forEach(function(product) {

        const deleteButton =
          product.querySelector('[data-stl-delete]');

        if (!deleteButton) {
          return;
        }

        deleteButton.addEventListener(
          'click',
          function(event) {

            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            removeProduct(product);

          }
        );

      });

      hotspots.forEach(function(hotspot) {

        hotspot.addEventListener('click', function(event) {

          event.preventDefault();
          event.stopPropagation();

          const index = hotspot.dataset.productIndex;

          const product = products.find(function(item) {
            return item.dataset.productIndex === index;
          });

          if (!product) {
            return;
          }

          if (product.dataset.available === 'false') {
            return;
          }

          toggleProduct(product);

          if (window.innerWidth <= 990) {

            const slot = panel.querySelector(
              '.stl-product-slot[data-slot-index="' + index + '"]'
            );

            if (slot) {

              slot.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });

            }

          }

        });

      });

      function showError(message) {

        if (!errorBox) {
          return;
        }

        errorBox.textContent = message;
        errorBox.classList.add('is-visible');

        window.clearTimeout(errorBox._timeout);

        errorBox._timeout = window.setTimeout(function() {
          errorBox.classList.remove('is-visible');
        }, 4000);
      }

      function getSelectedItems() {

        return products
          .filter(function(product) {
            return (
              product.classList.contains('is-selected') &&
              product.dataset.available !== 'false'
            );
          })
          .map(function(product) {

            return {
              id: Number(product.dataset.variantId),
              quantity: 1
            };

          })
          .filter(function(item) {
            return item.id;
          });

      }

      async function getCartSections() {
        const sectionNames = [
          'cart-drawer',
          'cart-count',
          'cart-icon-bubble',
          'cart-main'
        ];

        const uniqueNames = sectionNames.filter(function(name, index) {
          return sectionNames.indexOf(name) === index;
        });

        const url =
          getRoot() +
          '?sections=' +
          uniqueNames.join(',');

        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) {
          throw new Error('Unable to refresh cart.');
        }

        return await response.json();
      }

      function dispatchCartUpdate(sections, buttonElement) {

        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: {
              sections: sections,
              button: buttonElement
            },
            bubbles: true
          })
        );

      }

      function tryOpenNativeDrawer() {

        const drawer = document.querySelector(
          'theme-cart-drawer'
        );

        if (!drawer) {
          return false;
        }

        if (typeof drawer.open === 'function') {
          try {
            drawer.open();
            return true;
          } catch (e) {}
        }

        if (typeof drawer.show === 'function') {
          try {
            drawer.show();
            return true;
          } catch (e) {}
        }

        const details = drawer.querySelector('details');

        if (details && typeof details.open !== 'undefined') {
          details.open = true;
          return true;
        }

        return false;
      }

      async function refreshCartFallback() {

        try {

          const cartResponse = await fetch(
            getRoot() + 'cart.js',
            {
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              }
            }
          );

          if (!cartResponse.ok) {
            return;
          }

          const cart = await cartResponse.json();

          const countSelectors = [
            '[data-cart-count]',
            '.cart-count-bubble',
            '.cart-count',
            '#cart-icon-bubble'
          ];

          countSelectors.forEach(function(selector) {

            document
              .querySelectorAll(selector)
              .forEach(function(element) {

                if (
                  element.matches('.cart-count-bubble') ||
                  element.matches('.cart-count')
                ) {
                  element.textContent = cart.item_count;
                }

                element.dataset.cartCount = cart.item_count;

              });

          });

        } catch (error) {
          console.warn(
            'Shop The Look cart fallback:',
            error
          );
        }

      }

      button.addEventListener('click', async function(event) {

        event.preventDefault();

        if (button.disabled) {
          return;
        }

        const items = getSelectedItems();

        if (!items.length) {
          return;
        }

        const textElement =
          button.querySelector('.stl-button-text');

        const originalText =
          textElement
            ? textElement.textContent
            : '';

        button.disabled = true;
        button.classList.add('is-loading');

        if (textElement) {
          textElement.textContent = 'Adding...';
        }

        if (errorBox) {
          errorBox.classList.remove('is-visible');
        }

        try {

          const response = await fetch(
            getRoot() + 'cart/add.js',
            {
              method: 'POST',

              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },

              body: JSON.stringify({
                items: items
              })
            }
          );

          const data = await response.json();

          if (!response.ok) {

            const message =
              data.description ||
              data.message ||
              'Unable to add products to cart.';

            try {

              const sections =
                await getCartSections();

              dispatchCartUpdate(
                sections,
                button
              );

            } catch (refreshError) {}

            throw new Error(message);
          }

          let sections = null;

          try {
            sections = await getCartSections();
          } catch (sectionError) {
            console.warn(
              'Shop The Look sections refresh failed:',
              sectionError
            );
          }

          if (sections) {

            dispatchCartUpdate(
              sections,
              button
            );

          }

          await refreshCartFallback();

          const drawer =
            document.querySelector('theme-cart-drawer');

          if (!drawer) {

            if (redirectToCart) {
              window.location.href = getRoot() + 'cart';
              return;
            }

          } else {

            window.setTimeout(function() {
              tryOpenNativeDrawer();

            }, 80);

          }

          products.forEach(function(product) {

              product.classList.remove('is-selected');

              product.dataset.selected = 'false';

              product.setAttribute(
                'aria-pressed',
                'false'
              );

              const index = product.dataset.productIndex;

              const slot = panel.querySelector(
                '.stl-product-slot[data-slot-index="' + index + '"]'
              );

              if (slot) {
                slot.classList.remove('has-product');
                slot.dataset.slotProduct = '';
              }

            });

          hotspots.forEach(function(hotspot) {
            hotspot.classList.remove(
              'is-active'
            );
          });

          updateTotal();

        } catch (error) {

          console.error(
            'Shop The Look bundle error:',
            error
          );

          showError(
            error && error.message
              ? error.message
              : 'Unable to add products to cart.'
          );

        } finally {

          button.classList.remove(
            'is-loading'
          );

          if (textElement) {
            textElement.textContent =
              originalText;
          }

          updateTotal();

        }

      });

      updateTotal();

    });

  }

  function initAllShopTheLook() {
    document
      .querySelectorAll('.shop-the-look-hotspot-bundle')
      .forEach(initShopTheLook);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAllShopTheLook,
      { once: true }
    );
  } else {
    initAllShopTheLook();
  }

  document.addEventListener(
    'shopify:section:load',
    function(event) {
      const section = event.target.querySelector(
        '.shop-the-look-hotspot-bundle'
      );

      if (section) {
        initShopTheLook(section);
      }
    }
  );

  

})();

(function () {
  'use strict';

  function initSTLQuickView(sectionId) {
    const section = document.getElementById(sectionId);

    if (!section) return;

    if (section.dataset.quickViewInitialized === 'true') {
      return;
    }

    section.dataset.quickViewInitialized = 'true';

    const quickViewButtons = section.querySelectorAll(
      '[data-quick-view]'
    );

    if (!quickViewButtons.length) return;

    const quickViewDrawer = document.querySelector(
      '#quick-view-drawer'
    );

    if (!quickViewDrawer) {
      console.warn(
        'Shop The Look: #quick-view-drawer not found.'
      );
      return;
    }

    const quickViewInner =
      quickViewDrawer.querySelector(
        '.quick-view-drawer_inner'
      );

    if (!quickViewInner) {
      console.warn(
        'Shop The Look: .quick-view-drawer_inner not found.'
      );
      return;
    }

    function openDrawer() {
      quickViewDrawer.classList.add('active');

      quickViewDrawer.removeAttribute('inert');

      document.documentElement.classList.add(
        'quick-view-open'
      );

      document.body.classList.add(
        'quick-view-open'
      );
    }

    function closeDrawer() {
      quickViewDrawer.classList.remove('active');

      window.setTimeout(function () {
        if (
          !quickViewDrawer.classList.contains('active')
        ) {
          quickViewDrawer.setAttribute('inert', '');
        }
      }, 450);

      document.documentElement.classList.remove(
        'quick-view-open'
      );

      document.body.classList.remove(
        'quick-view-open'
      );
    }

    const closeButton =
      quickViewDrawer.querySelector(
        '.quick_view_close'
      );

    if (closeButton) {
      closeButton.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();

          closeDrawer();
        }
      );
    }

    function findProductSection(doc) {
      const selectors = [
        'section[id^="MainProduct-"]',
        'section[id*="main-product"]',
        'section[id*="product-template"]',
        'section.product',
        '.shopify-section:has(product-info)',
        '.shopify-section:has(product-form)'
      ];

      for (
        let i = 0;
        i < selectors.length;
        i++
      ) {
        try {
          const element =
            doc.querySelector(
              selectors[i]
            );

          if (element) {
            return element;
          }
        } catch (error) {}
      }

      const productForm =
        doc.querySelector(
          'product-form'
        );

      if (productForm) {
        const parent =
          productForm.closest(
            'section, .shopify-section, .product'
          );

        if (parent) {
          return parent;
        }
      }

      const form =
        doc.querySelector(
          'form[action*="/cart/add"]'
        );

      if (form) {
        const parent =
          form.closest(
            'section, .shopify-section, .product'
          );

        if (parent) {
          return parent;
        }
      }

      return null;
    }

    function cleanProductContent(container) {
      const removeSelectors = [
        'product-recommendations',
        '.product-recommendations',
        '.product__recommendations',
        '.related-products',
        '.product-related',
        '.related-products-section',
        'complementary-products',
        '.complementary-products',
        '.recently-viewed',
        '.recently-viewed-products',
        '.product-faq',
        '.product__faq',
        '.faq',
        '.faqs',
        '.faq-section',
        '.product-reviews',
        '.reviews',
        '#reviews',
        '.product-questions',
        '.breadcrumbs',
        '.breadcrumb',
        '.share-button',
        '.share-buttons',
        'pickup-availability',
        '.shopify-payment-button',
        '[data-product-recommendations]',
        '[data-related-products]'
      ];

      container
        .querySelectorAll(
          removeSelectors.join(',')
        )
        .forEach(function (element) {
          element.remove();
        });

      container
        .querySelectorAll(
          '.shopify-section'
        )
        .forEach(function (element) {
          if (
            element.querySelector('product-form') ||
            element.querySelector(
              'form[action*="/cart/add"]'
            ) ||
            element.querySelector('product-info')
          ) {
            return;
          }

          element.remove();
        });

      return container;
    }

    async function loadQuickView(productUrl) {
      if (!productUrl) return;

      quickViewInner.innerHTML = `
        <div class="stl-qv-loading">
          <span></span>
          <span></span>
          <span></span>
        </div>
      `;

      openDrawer();

      try {
        const response =
          await fetch(
            productUrl,
            {
              method: 'GET',

              headers: {
                'X-Requested-With':
                  'XMLHttpRequest',

                'Accept':
                  'text/html'
              }
            }
          );

        if (!response.ok) {
          throw new Error(
            'Unable to load product.'
          );
        }

        const html =
          await response.text();

        const parser =
          new DOMParser();

        const doc =
          parser.parseFromString(
            html,
            'text/html'
          );

        const productSection =
          findProductSection(doc);

        if (!productSection) {
          throw new Error(
            'Main product section not found.'
          );
        }

        const clonedProduct =
          productSection.cloneNode(true);

        cleanProductContent(
          clonedProduct
        );

        let productContent =
          clonedProduct;

        const productInner =
          clonedProduct.querySelector(
            'product-info'
          );

        if (productInner) {
          productContent =
            productInner.cloneNode(true);
        }

        if (!productInner) {
          const infoWrapper =
            clonedProduct.querySelector(
              '.product__info-wrapper, ' +
              '.product-information, ' +
              '.product-info, ' +
              '.product__info-container'
            );

          if (infoWrapper) {
            productContent =
              infoWrapper.cloneNode(true);
          }
        }

        cleanProductContent(
          productContent
        );

        quickViewInner.innerHTML = '';

        quickViewInner.appendChild(
          productContent
        );

        fixDuplicateIds(
          quickViewInner
        );

        executeScripts(
          quickViewInner
        );

        initializeQuickViewElements(
          quickViewInner
        );

        document.dispatchEvent(
          new CustomEvent(
            'quickview:loaded',
            {
              detail: {
                container:
                  quickViewInner,

                productUrl:
                  productUrl
              },

              bubbles: true
            }
          )
        );

      } catch (error) {
        console.error(
          'Shop The Look Quick View:',
          error
        );

        quickViewInner.innerHTML = `
          <div class="stl-qv-error">
            <p>
              Unable to load product.
            </p>

            <a href="${productUrl}">
              View Product
            </a>
          </div>
        `;
      }
    }

    function fixDuplicateIds(container) {
      const elements =
        container.querySelectorAll('[id]');

      elements.forEach(function (element) {
        const oldId =
          element.id;

        const existing =
          document.getElementById(oldId);

        if (
          existing &&
          existing !== element
        ) {
          element.id =
            'qv-' +
            oldId;
        }
      });
    }

    function executeScripts(container) {
      const scripts =
        Array.from(
          container.querySelectorAll('script')
        );

      scripts.forEach(function (oldScript) {
        const newScript =
          document.createElement('script');

        Array.from(
          oldScript.attributes
        ).forEach(function (attribute) {
          newScript.setAttribute(
            attribute.name,
            attribute.value
          );
        });

        newScript.textContent =
          oldScript.textContent;

        oldScript.replaceWith(
          newScript
        );
      });
    }

    function initializeQuickViewElements(container) {
      window.setTimeout(
        function () {
          container
            .querySelectorAll('product-info')
            .forEach(function (element) {
              try {
                if (
                  typeof element.connectedCallback ===
                  'function'
                ) {
                  // Custom element already initialized
                }
              } catch (error) {}
            });

          container
            .querySelectorAll('product-form')
            .forEach(function (element) {
              try {
                element.dispatchEvent(
                  new CustomEvent(
                    'quickview:initialize',
                    {
                      bubbles: true
                    }
                  )
                );
              } catch (error) {}
            });

          container
            .querySelectorAll(
              'variant-selects, variant-radios'
            )
            .forEach(function (element) {
              try {
                element.dispatchEvent(
                  new Event(
                    'change',
                    {
                      bubbles: true
                    }
                  )
                );
              } catch (error) {}
            });

          if (
            window.Shopify &&
            Shopify.PaymentButton &&
            typeof Shopify.PaymentButton.init ===
              'function'
          ) {
            try {
              Shopify.PaymentButton.init();
            } catch (error) {}
          }
        },
        50
      );
    }

    quickViewButtons.forEach(function (button) {
      button.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          const productUrl =
            button.dataset.productUrl;

          if (!productUrl) {
            console.warn(
              'Quick View: product URL missing.'
            );
            return;
          }

          loadQuickView(productUrl);
        }
      );
    });

    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key !== 'Escape') {
          return;
        }

        if (
          !quickViewDrawer.classList.contains(
            'active'
          )
        ) {
          return;
        }

        closeDrawer();
      }
    );

    quickViewDrawer.addEventListener(
      'click',
      function (event) {
        if (
          event.target.closest(
            '.quick_view_wrapper_in'
          )
        ) {
          return;
        }

        closeDrawer();
      }
    );
  }

  function initFromScript(script) {
    if (!script) return;

    const sectionId =
      script.dataset.sectionId;

    if (!sectionId) {
      console.warn(
        'Shop The Look Quick View: section ID missing.'
      );
      return;
    }

    initSTLQuickView(
      'shop-the-look-hotspot-' + sectionId
    );
  }

  function findQuickViewScripts() {
    return document.querySelectorAll(
      'script[src*="shop-the-look-quick-view.js"]'
    );
  }

  function initAllSections() {
    findQuickViewScripts().forEach(
      function (script) {
        initFromScript(script);
      }
    );
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initAllSections,
      {
        once: true
      }
    );
  } else {
    initAllSections();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      if (
        !event.detail ||
        !event.detail.sectionId
      ) {
        return;
      }

      const sectionId =
        'shop-the-look-hotspot-' +
        event.detail.sectionId;

      const section =
        document.getElementById(sectionId);

      if (section) {
        section.dataset.quickViewInitialized =
          'false';

        initSTLQuickView(sectionId);
      }
    }
  );
})();
